<nav *ngIf="becare.authenticated" class="navbar navbar-expand-lg navbar-fixed-top">
  <app-logoinfo class="navbar-brand"></app-logoinfo>
  <div class="navbar-nav">
    <div class="navbar-item" style="width:470px;">
      <app-patientsearch style="position: absolute;top:5px;"></app-patientsearch><br>
      <app-patientinfo style="position: absolute;top:45px;z-index:2;width: 456px;"></app-patientinfo>  
    </div>
    <div class="navbar-item" style="position:relative;">
      <app-patientehealthinfo style="float:left;"></app-patientehealthinfo>
      <app-patientotherinfo style="float:left;"></app-patientotherinfo>
    </div>
  </div>
  <div *ngIf="patient.patient" class="navbar-nav ml-auto" style="top:5px;width:240px;flex-direction: column;">
    <form class="field-full-width">
      <mat-form-field class="field-full-width" appearance="legacy">
        <mat-label>Recherche dossier</mat-label>
        <input type="text" matInput placeholder="Votre recherche">
        <fa-icon matSuffix [icon]="['fas','search']"></fa-icon>
      </mat-form-field>
    </form>
    <app-jobstatus></app-jobstatus>
  </div>
  <div *ngIf="userConfig.profileValue('SNWaitingRoom','display') === 'header'" class="navbar-nav ml-auto" style="top:5px;width:300px;overflow: hidden;">
    <app-agenda-waiting-header class="waiting-room" style="clear: both;"></app-agenda-waiting-header>
  </div>
  <div class="navbar-nav ml-auto" style="top:5px;width:287px;height:75px;position:relative;">
    <div style="width:130px;float:right;">
      <app-addressbook style="height:35px;"></app-addressbook>
      <app-agenda-header-list style="height:35px;" *ngIf="userConfig.profileValue('SNAgenda','display') === 'header'"></app-agenda-header-list>
    </div>
    <div style="width:170px;float:right;">
      <app-userinfo style="position:relative;"></app-userinfo>
    </div>
  </div>
</nav>
<div style="height:38px;width:100%;position:relative;">
  <div style="width:calc(100vw - 600px);margin-left:600px;height:38px;">
    <app-user-open-items></app-user-open-items>
  </div>
</div>